<template>
  <v-card
    class="ma-0"
    width="100%"
    style="height: auto"
    elevation="2"
  >
    <v-app-bar
      flat
      class="my-0 mb-6 py-1 px-2"
      dense
      height="30"
    >
      <v-toolbar-title class="mt-4 me-4">{{ $t('productPricing') }}</v-toolbar-title>
      <div
        v-if="!isMobile && !isTablet"
        style="width: 230px;"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </div>
      <v-spacer />
      <v-btn
        v-if="selected.length > 0 && !isMobile"
        outlined
        @click="deletDialog = true"
        class="mt-4 ms-2"
        color="pink"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('remove') }}
        </p>
        <v-icon>
          mdi-trash-can-outline
        </v-icon>
      </v-btn>
      <v-menu
        offset-y
      >
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            outlined
            class="mt-4 px-1 ms-2"
            color="grey darken-2"
            height="32"
            v-bind="attrs"
            v-on="on"
            style="min-width: 35px !important;padding: 0 !important;"
          >
            <!-- <p class="mb-0 me-2">
              {{$t('more')}}
            </p> -->
            <v-icon>
              mdi-dots-vertical
            </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
            link
            @click="openUploadDialog"
          >
            <v-list-item-icon>
              <v-icon>mdi-database-import-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('importData')" />
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @click="getItems"
          >
            <v-list-item-icon>
              <v-icon>mdi-refresh</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('refresh')" />
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @getAllRows="getAllRows"
          >
          <export-excel
            ref="refExcel"
            :data="excelItems"
            worksheet="abriron.com"
            name="data.xls"
            type="xls"
            class="float-left d-flex"
            :title="$store.state.abrName"
            :total-prop="pageCount"
            :page-prop="excelPage"
            @getAllRows="getAllRows"
          >
            <v-list-item-icon>
              <v-icon>mdi-file-excel-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('excel')" />
          </export-excel>
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @click="printDialog = true"
          >
            <v-list-item-icon>
              <v-icon>mdi-printer-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('print')" />
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @click="goTo('Product')"
          >
            <v-list-item-icon>
              <v-icon>mdi-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('product')" />
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="getItems"
        class="mt-4 px-1 ms-2"
        color="grey darken-2"
        height="32"
        style="min-width: 35px !important;padding: 0 !important;"
      >
        <!-- <p class="mb-0 me-2">
          {{$t('refresh')}}
        </p> -->
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>
      <export-excel
        v-if="!isMobile && !isTablet"
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data.xls"
        type="xls"
        class="float-left"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <v-btn
          outlined
          class="mt-4 ms-2"
          color="grey darken-2 "
          height="32"
        >
          <p class="font-weight-thin mb-0 me-2">
            {{ $t('excel') }}
          </p>
          <v-icon>
            mdi-file-excel-outline
          </v-icon>
        </v-btn>
      </export-excel>
      <v-btn
        outlined
        @click="filter = true"
        class="mt-4 ms-2"
        color="grey darken-2 "
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('filter') }}
        </p>
        <v-icon>
          mdi-filter-outline
        </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="printDialog = true"
        class="mt-4  ms-2"
        color="grey darken-2"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('print') }}
        </p>
        <v-icon>
          mdi-printer-outline
        </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="goTo('Product')"
        class="mt-4 ms-2"
        color="primary"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('product') }}
        </p>
        <v-icon>
          mdi-plus
        </v-icon>
      </v-btn>
    </v-app-bar>
    <v-row
      v-if="isMobile || isTablet"
      class="mx-0"
    >
      <v-col
        class="mb-4 px-2"
        cols="12"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-col
      cols="12"
      class="px-2"
      :class="{ 'mt-2': !isMobile && !isTablet , 'mt-0': isMobile || isTablet}"
    >
      <v-data-table
        v-if="headers"
        :height="(isMobile || isTablet || mobileShow ? 323 : tableHeight)"
        fixed-header
        v-model="selected"
        :headers="showHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        multi-sort
        :single-expand="false"
        :expanded.sync="expanded"
        show-expand
        expand
        dense
        :show-select="showSelect"
        item-key="id"
        class="mb-2 td-hide-border"
        style="border: 1px solid #e3e3e3;border-radius: 6px;"
        :footer-props="{
          showFirstLastPage: (!mobileShow ? true : false),
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus'
        }"
      >
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">

            <v-simple-table style="background-color: antiquewhite">
              <template v-slot:default>
                <thead>
                <tr>
                  <th> {{ $t('firstCost') }}</th>
                  <th>{{ $t('minCost') }}</th>
                  <th>{{ $t('averageCost') }}</th>
                  <th>{{ $t('maxCost') }}</th>
                  <th>{{ $t('lastCost') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>{{ $numberFormat(item.costs.first) }}</td>
                  <td>{{ $numberFormat(item.costs.min) }}</td>
                  <td>{{ $numberFormat(item.costs.average) }}</td>
                  <td>{{ $numberFormat(item.costs.max) }}</td>
                  <td>{{ $numberFormat(item.costs.last) }}</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </td>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex">
            <v-btn
              v-if="item.edit"
              color="primary"
              x-small
              class="mt-3"
              :loading="loading"
              @click="update(item)"
            >
              {{ $t('submit') }}
            </v-btn>
            <v-menu
              offset-y
            >
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  color="primary"
                  v-bind="attrs"
                  icon
                  v-on="on"
                >
                  <v-icon
                    medium
                  >
                    mdi-dots-vertical
                  </v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item
                  link
                  @click="openDeleteDialog(item)"
                >
                  <v-list-item-icon>
                    <v-icon color="pink">
                      mdi-trash-can-outline
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-title v-text="$t('remove')" />
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
        <template v-slot:item.row="{ item }">
          {{ parseInt(items.indexOf(item))+ parseInt(from) }}
        </template>
        <template v-slot:item.product.name="{ item }">
          <h4>{{ item.product.name }}</h4>
        </template>
        <template v-slot:item.type="{ item }">
          {{ $t(item.type) }}
        </template>
        <template v-slot:item.name="{ item }">
          <v-text-field
            v-model="item.name"
            height="20"
            dense
            solo
            flat
            :rules="[v => !!v || $t('is-required')]"
            class="mb-3 dense"
            clearable
            :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
            :placeholder="$t('name')"
            @change="item.edit = true"
          />
        </template>
        <template v-slot:item.category.name="{ item }">
          <autocomplete
            v-model="item.category"
            :label="$t('account-category')"
            type="accountCategory"
            class="mb-3"
            :value="item.category"
            @blur="item.edit = true"
          />
        </template>
        <template v-slot:item.currency.name="{ item }">
          <autocomplete
            ref="refCategory"
            v-model="item.currency"
            :label="$t('account-category')"
            type="currency"
            class="mb-3"
            :set-init="true"
            :value="item.currency"
            @blur="item.edit = true"
          />
        </template>
        <template v-slot:item.min="{ item }">
          <v-text-field
            v-model="item.min"
            height="20"
            dense
            solo
            flat
            class="mb-3 dense"
            :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
            :placeholder="$t('count')"
            type="number"
            @change="item.edit = true"
          />
        </template>
        <template v-slot:item.max="{ item }">
          <v-text-field
            v-model="item.max"
            height="20"
            dense
            solo
            flat
            class="mb-3 dense"
            :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
            :placeholder="$t('count')"
            type="number"
            @change="item.edit = true"
          />
        </template>
        <template v-slot:item.woocommerce="{ item }">
          <div>
            <v-checkbox
              v-model="item.woocommerce"
              class="mx-4 ma-0 mb-3"
              style="height: 20px"
              value="active"
            />
          </div>
        </template>
        <template v-slot:item.portal="{ item }">
          <div>
            <v-checkbox
              v-model="item.portal"
              class="mx-4 ma-0 mb-3"
              style="height: 20px"
              value="active"
            />
          </div>
        </template>
        <template v-slot:item.percent="{ item }">
          <v-text-field
            v-model="item.percent"
            height="20"
            dense
            solo
            flat
            class="mb-3 dense"
            clearable
            :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
            :placeholder="$t('percent')"
            type="number"
            @keyup="calPrice(item)"
          />
        </template>
        <template v-slot:item.price="{ item }">
          <money
            v-model="item.price"
            :dense="true"
            :outlined="true"
            :solo="false"
            :clearable="true"
            value-when-is-empty=""
            :options="options"
            class="mb-3 dense"
            @input="calPrice(item)"
          />
        </template>
      </v-data-table>
    </v-col>
    <v-row />
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="filter"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="filter = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('filter') }}
          </p>
        </v-col>
        <v-row class="ma-0">
<!--          <v-col-->
<!--            cols="12"-->
<!--            md="4"-->
<!--          >-->
<!--            <v-select-->
<!--              v-model="productStatus"-->
<!--              :label="$t('status')"-->
<!--              :items="productStatusItems"-->
<!--              height="30"-->
<!--              dense-->
<!--              outlined-->
<!--              multiple-->
<!--              clearable-->
<!--              item-value="value"-->
<!--              item-text="text"-->
<!--            />-->
<!--          </v-col>-->
          <v-col md="4">
            <autocomplete
              v-model="group"
              :title="$t('main-group')"
              type="productGroup"
              :data="JSON.stringify({parent:null,type:'group'})"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="cat1"
              :title="$t('other-group')"
              type="productGroup"
              :data="JSON.stringify({parent:null,type:'category'})"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="cat2"
              title="category"
              type="productGroup"
              :data="JSON.stringify({parent:null,type:'subcategory'})"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="registerar"
              :title="$t('registerar')"
              type="partners"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="Select Columns"
              height="30"
              dense
              outlined
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip
                  v-if="index < 2"
                  small
                >
                  <span>{{ item.text }}</span>
                </v-chip>
                <v-chip
                  v-if="index === 1"
                  small
                >
                  <span>(+{{ selectedHeaders.length - 2 }} {{ $t('other') }})</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
        </v-row>
        <v-card-actions class="px-3">
          <v-row class="ma-0 px-0">
            <v-col
              class="pa-0 py-3"
              cols="6"
            >
              <v-btn
                class=" mx-0"
                color="primary"
                @click="getItems"
              >
                {{ $t('filter') }}
              </v-btn>
            </v-col>
            <v-col
              class="pa-0 py-3"
              cols="6"
            >
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    upload dialog-->
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="uploadDialog"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="uploadDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col
          class="mt-0 pt-0 pr-7"
        >
          <upload
            type-prop="pricing"
            :get-item="uploadDialog"
            @close="uploadDialog=false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
  import Task from '../task/task'
  import Print from '../../components/general/Print/Index'
  import General from '../../../../Mixins/general'
  import Upload from '../../components/general/upload/upload'
  export default {
    name: 'pricingList',
    components: {
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      autocomplete: () => import('../../components/general/patial/autocomplete'),
      Upload,
      Print,
      Task,
    },
    mixins: [General],
    props: ['input', 'type', 'refId', 'mobileShow'],
    data: () => ({
      excelItems: [],
      selected: [],
      expanded: [],
      inventoryStatus: null,
      inventoryStatusItems: null,
      group: null,
      cat1: null,
      cat2: null,
      registerar: null,
      selectedHeaders: [],
      uploadDialog: false,
      printDialog: false,
      deletDialog: false,
      filter: false,
      productStatus: null,
      productStatusItems: null,
      model: null,
      from: 1,
      taskDialog: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      pageCount: 1,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      typeForm: null,
      taskId: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      headers: null,
      search: null,
    }),
    computed: {
      showSelect () {
        if(!this.isMobile) {
          return true
        } else {
          return false
        }
      },
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          if (app.typeForm === 'service') {
            if (s.value === 'stock' || s.value === 'order_point') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          } else {
            return app.selectedHeaders.includes(s)
          }
        })
      },
    },
    watch: {
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          this.getItems()
        },
        deep: true,
        immediate: false,
      },
    },
    activated () {
      this.getItems()
    },
    beforeMount () {
      if (this.$route.name === 'ProductList') {
        this.typeForm = 'product'
      } else {
        this.typeForm = 'service'
      }
      this.headers = [
        {
          text: this.$t('row'),
          align: 'start',
          sortable: false,
          value: 'row',
        },
        {
          text: this.$t('product') + '/' + this.$t('service'),
          sortable: false,
          value: 'product.name',
          width: 150,
        },
        {
          text: this.$t('type'),
          sortable: false,
          value: 'type',
        },
        {
          text: this.$t('name'),
          sortable: false,
          value: 'name',
        },
        {
          text: this.$t('account-category'),
          sortable: false,
          value: 'category.name',
        },
        {
          text: this.$t('branch'),
          sortable: false,
          value: 'branch.name',
        },
        {
          text: this.$t('currency'),
          sortable: false,
          value: 'currency.name',
        },
        {
          text: this.$t('min') + '(' + this.$t('count') + ')',
          sortable: false,
          value: 'min',
          width: 100,
        },
        {
          text: this.$t('max') + '(' + this.$t('count') + ')',
          sortable: false,
          value: 'max',
          width: 100,
        },
        {
          text: this.$t('woocommerce'),
          sortable: false,
          value: 'woocommerce',
        },
        {
          text: this.$t('portal'),
          sortable: false,
          value: 'portal',
        },
        {
          text: this.$t('percent'),
          sortable: false,
          value: 'percent',
        },
        {
          text: this.$t('price'),
          sortable: false,
          value: 'price',
        },
        {
          text: '#',
          align: 'start',
          sortable: false,
          value: 'actions',
        },
      ]
      this.productStatusItems = [
        {
          value: 'active',
          text: this.$t('active'),
        },
        {
          value: 'deactive',
          text: this.$t('deactive'),
        },
      ]
      this.inventoryStatusItems = [
        {
          value: '>',
          text: this.$t('available'),
        },
        {
          value: '=',
          text: this.$t('unavailable'),
        },
        {
          value: '<',
          text: this.$t('negetive'),
        },
        {
          value: 'orderpoint',
          text: this.$t('orderpoint'),
        },
      ]
      if (this.input) {
        this.model = this.input
      }
      this.headersMap = this.headers
      this.selectedHeaders = this.headers
    },
    mounted () {
      this.getItems()
    },
    methods: {
      calPrice (item) {
        if (item.percent && item.type === 'price') {
          var profit = parseFloat(item.costs[item.cost_method]) * (item.percent / 100)
          item.price = parseFloat(profit) + parseFloat(item.costs[item.cost_method])
        } else {
          item.percent = null
        }
        item.edit = true
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openUploadDialog (item) {
        this.uploadDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: 'ProductEdit', params: { id: item.id } })
      },
      turnover (item, entrepot) {
        this.$router.push({ name: 'productTurnover', params: { productProp: item, entrepotProp: entrepot } })
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'pricing', {
          params: {
            inventoryStatus: app.inventoryStatus,
            group: app.group,
            cat1: app.cat1,
            cat2: app.cat2,
            registerar: app.registerar,
            search: app.search,
            page: (app.allRows ? app.excelPage : app.options.page),
            refId: app.refId,
            type: app.type,
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.options,
            tag: app.tag,
            typeForm: app.typeForm,
          },
        })
          .then(res => {
            res = res.data
            if (!app.allRows) {
              app.items = res.data
              app.totalItems = res.total
              app.pageCount = res.last_page
              app.from = res.from
              app.creatExcelData(res.data)
            } else {
              app.generateExcellForAllData(res.data, res.last_page)
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'pricing/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      update (item) {
        var app = this
        app.loading = true
        app.$axios.put(this.$endpoint + 'pricing/' + item.id, item)
          .then(res => {
            res = res.data
            item.edit = false
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.loading = false
            app.snakbar = false
          })
      },
      removegroup () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'products', {
          params: {
            deleteItems: app.selected,
          },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      creatExcelData (data, type = 'page') {
        var app = this
        if (type === 'page') {
          app.excelItems = []
        }
        data.map(function (d) {
          app.excelItems.push({
            type: d.type,
            name: d.name,
            product_name: (d.product ? d.product.name : null),
            product_id: (d.product ? d.product.id : null),
            min_count: d.min,
            max_count: d.max,
            category_name: (d.category ? d.category.name : null),
            cost_method: d.cost_method,
            currency_id: (d.currency ? d.currency.id : null),
            price: d.price,
            percent: d.percent,
            branch_name: (d.branch ? d.branch.name : null),
          })
        })
      },
    },
  }
</script>

<style scoped>
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 32px !important;
}
</style>
